export default __webpack_public_path__ + "static/media/mic@3x.11ee60a8.png";